import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../../services/http.js';

export function CreditDashboard() {
    const [credits, setCredits] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchCredits = async () => {
            try {
                const { res, data } = await apiClient.request('/billing/credits');
                if (!res.ok) throw new Error('credits_failed');
                setCredits(data);
            } finally {
                setLoading(false);
            }
        };

        fetchCredits();
    }, []);

    if (loading || !credits) return <div>Carregando...</div>;

    const isTrial = credits.plan === 'trial';
    const percentageUsed = credits.allocated > 0
        ? Math.min(100, Math.round((credits.consumed / credits.allocated) * 100))
        : 0;

    return (
        <div className="space-y-6">


            {/* Cards de crédito */}
            <div className="grid md:grid-cols-3 gap-4">
                <div className="bg-surface-container-low rounded-lg p-6 border border-outline-variant">
                    <div className="text-sm text-on-surface-variant mb-2">Créditos Disponíveis</div>
                    <div className="text-3xl font-bold text-primary">{credits.available}</div>
                </div>

                <div className="bg-surface-container-low rounded-lg p-6 border border-outline-variant">
                    <div className="text-sm text-on-surface-variant mb-2">Consumido</div>
                    <div className="text-3xl font-bold">{credits.consumed}</div>
                    <div className="text-xs text-on-surface-variant">{percentageUsed}% de {credits.allocated}</div>
                </div>

                <div className="bg-surface-container-low rounded-lg p-6 border border-outline-variant">
                    <div className="flex items-center gap-2 mb-2">
                        <span className="text-sm text-on-surface-variant">Plano Atual</span>
                        {isTrial && (
                            <span className="text-[10px] font-bold uppercase tracking-wider bg-primary/15 text-primary px-2 py-0.5 rounded-full">
                                Trial
                            </span>
                        )}
                    </div>
                    <div className="text-3xl font-bold capitalize">
                        {isTrial ? 'Trial' : credits.plan}
                    </div>
                    {!isTrial && (
                        <div className="text-xs text-on-surface-variant">
                            Renova: {new Date(credits.reset_date).toLocaleDateString('pt-BR')}
                        </div>
                    )}
                </div>
            </div>

            {/* Barra de progresso */}
            <div className="bg-surface-container-low rounded-lg p-6 border border-outline-variant">
                <div className="mb-3 flex justify-between">
                    <span className="font-semibold">
                        {isTrial ? 'Créditos do Trial' : 'Progresso da Semana'}
                    </span>
                    <span className="text-primary font-semibold">{percentageUsed}%</span>
                </div>
                <div className="w-full bg-surface-container-lowest rounded-full h-3">
                    <div
                        className="h-full rounded-full bg-primary"
                        style={{ width: `${percentageUsed}%` }}
                    />
                </div>
                {isTrial && (
                    <p className="text-xs text-on-surface-variant mt-3">
                        O trial concede {credits.allocated} mensagens válidas por 30 dias.
                        Após o término, assine um plano para continuar.
                    </p>
                )}
                {!isTrial && (
                    <p className="text-xs text-on-surface-variant mt-3">
                        Seus créditos renovam toda segunda-feira. Use quantas quiser até lá.
                    </p>
                )}
            </div>
        </div>
    );
}
